var DefaultGraphCategories = /** @class */ (function () {
    function DefaultGraphCategories() {
    }
    DefaultGraphCategories.Switch = 'Switch';
    DefaultGraphCategories.IndicatorLight = 'IndicatorLight';
    DefaultGraphCategories.ToggleView = 'ToggleView';
    DefaultGraphCategories.Character = 'Character';
    DefaultGraphCategories.NumericalDisplay = 'NumericalDisplay';
    DefaultGraphCategories.Background = 'Background';
    return DefaultGraphCategories;
}());
export { DefaultGraphCategories };
